export const defaultControlSchemes = {
    desktop: {
        id: 'desktop',
        movement: 'pointerLock',
        bindings: [
            {
                id: 'keyboard-primary',
                event: 'keydown',
                target: 'window',
                action: 'handleKeyboardPrimary',
                keys: ['Slash', 'KeyT', 'Backquote', 'KeyC', 'KeyP', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9'],
                options: { capture: true },
            },
            {
                id: 'wheel-ability',
                event: 'wheel',
                target: 'document',
                action: 'handleWheelAbility',
                options: { passive: false },
            },
            {
                id: 'click-ability',
                event: 'click',
                target: 'document',
                action: 'handleAbilityClick',
            },
            {
                id: 'touch-ability',
                event: 'touchstart',
                target: 'document',
                action: 'handleAbilityTouch',
                options: { passive: true },
            },
            {
                id: 'auxclick-inspect',
                event: 'auxclick',
                target: 'document',
                action: 'handleInspectAuxClick',
                button: 1,
                options: { passive: false },
            },
            {
                id: 'ability-mousedown',
                event: 'mousedown',
                target: 'document',
                action: 'handleAbilityMouseDown',
            },
            {
                id: 'ability-mouseup',
                event: 'mouseup',
                target: 'document',
                action: 'handleAbilityMouseUp',
            },
        ],
    },
    mobile: {
        id: 'mobile',
        movement: 'touchLook',
        bindings: [
            {
                id: 'keyboard-primary-mobile',
                event: 'keydown',
                target: 'window',
                action: 'handleKeyboardPrimary',
                keys: ['Slash', 'KeyT', 'Backquote', 'KeyC', 'KeyP', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9'],
                options: { capture: true },
            },
            {
                id: 'wheel-ability-mobile',
                event: 'wheel',
                target: 'document',
                action: 'handleWheelAbility',
                options: { passive: false },
            },
            {
                id: 'click-ability-mobile',
                event: 'click',
                target: 'document',
                action: 'handleAbilityClick',
            },
            {
                id: 'touch-ability-mobile',
                event: 'touchstart',
                target: 'document',
                action: 'handleAbilityTouch',
                options: { passive: true },
            },
            {
                id: 'auxclick-inspect-mobile',
                event: 'auxclick',
                target: 'document',
                action: 'handleInspectAuxClick',
                button: 1,
                options: { passive: false },
            },
            {
                id: 'ability-mousedown-mobile',
                event: 'mousedown',
                target: 'document',
                action: 'handleAbilityMouseDown',
            },
            {
                id: 'ability-mouseup-mobile',
                event: 'mouseup',
                target: 'document',
                action: 'handleAbilityMouseUp',
            },
        ],
    },
};
export const defaultControlSchemeIds = {
    desktop: 'desktop',
    mobile: 'mobile',
};
